import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useSearchParams } from "react-router-dom";

type Props = {};

export const ExpiredFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const includeExpired = searchParams.get("expired") === "true";

	const handleFilter = (e: any) => {
		if (e.target.checked) {
			searchParams.set("expired", "true");
		} else {
			searchParams.delete("expired");
		}
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<FormControlLabel
			sx={{ m: 0, whiteSpace: "nowrap" }}
			control={
				<Checkbox
					checked={includeExpired}
					onChange={handleFilter}
					size="small"
				/>
			}
			label="Include expired"
		/>
	);
};
